import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'activeInactive',
    standalone: false
})
export class ActiveInactivePipe implements PipeTransform {

  public values: any[] = [];
  public activeValue;
  public inactiveValueValue;

  constructor(public translateService: TranslateService) {
    this.activeValue = this.translateService.instant('BOOLEANS.ACTIVE');
    this.inactiveValueValue = this.translateService.instant('BOOLEANS.INACTIVE');
    this.values.push({id: 'true', name:this.activeValue, text:this.activeValue});
    this.values.push({id: 'false', name:this.inactiveValueValue, text:this.inactiveValueValue});
  }

  transform(value: any): string {
    if (typeof value === 'boolean') {
      return value ? this.activeValue : this.inactiveValueValue;
    } else if (typeof value === 'number') {
      return value === 1 ? this.activeValue : this.inactiveValueValue;
    } else if (typeof value === 'string') {
      const lowerCaseValue = value.toLowerCase();
      if (lowerCaseValue === 'true' || lowerCaseValue === '1') {
        return this.activeValue;
      } else if (lowerCaseValue === 'false' || lowerCaseValue === '0') {
        return this.inactiveValueValue;
      }
    }

    // fallback for unexpected values
    return '-';
  }
}
